import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

import Recomendaciones from "../../components/Recomendaciones";

export default class Empleos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recomendaciones: [],
      recomendacionesAll: [],
      applicant: [],
    };
    this.filterRecommends = this.filterRecommends.bind(this);
    this.sortData = this.sortData.bind(this);
  }

  componentDidMount() {
    let config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
      },
    };

    axios
      .get("access/applicant/" + localStorage.getItem("userId"), config)
      .then((result) => {
        this.setState({
          applicant: result.data,
        });
      });

    axios({
      method: "get",
      url: `/company-vacant/list`,
    })
      .then((response) => {
        this.setState({
          recomendaciones: response.data,
          recomendacionesAll: response.data,
        });
      })
      .catch((error) => {
        this.setState({
          errorMsg: error,
        });
      });
  }

  filterRecommends(e) {
    const all = this.state.recomendacionesAll;

    if (e.target.value === "" || e.target.value === "undefined")
      this.componentDidMount();
    else {
      function filterItems(val) {
        return all.filter(function (e) {
          var cargo = e.vacantDTOResponse.cargo
            .toLowerCase()
            .indexOf(val.toLowerCase());
          var empresa = e.vacantDTOResponse.name
            .toLowerCase()
            .indexOf(val.toLowerCase());
          var ubicacion = e.vacantDTOResponse.ubicacion
            .toLowerCase()
            .indexOf(val.toLowerCase());
          var tipoEmpleo = e.vacantDTOResponse.tipoEmpleo
            .toLowerCase()
            .indexOf(val.toLowerCase());
          if (cargo > -1 || empresa > -1 || ubicacion > -1 || tipoEmpleo > -1) {
            return e;
          }
        });
      }

      this.setState({
        recomendaciones: filterItems(e.target.value),
      });
    }
  }

  sortData(e) {
    const all = this.state.recomendacionesAll;
    if (e.target.value === "" || e.target.value === "undefined")
      this.componentDidMount();
    else {
      function filterItems(val) {
        if (val === "1") {
          return all.sort(function (a, b) {
            return (
              a.vacantDTOResponse.companyVacantId -
              b.vacantDTOResponse.companyVacantId
            );
          });
        } else {
          return all.sort(function (a, b) {
            return (
              b.vacantDTOResponse.companyVacantId -
              a.vacantDTOResponse.companyVacantId
            );
          });
        }
      }
      // let dta = filterItems(e.target.value);
      // console.log(dta);
      this.setState({
        recomendaciones: filterItems(e.target.value),
      });
    }
  }

  render() {
    return (
      <div className="profile">
        <div className="notificaciones">
          <div className="container" >
            <div className="row"id="headerempleos" >
              <div className="col-6">
                <div className="left-content">Activar Alertas de Trabajo</div>
              </div>

              <div className="col-6">
                <div className="right-content">
                  {/* <Link
                    to="/user/BusquedaEmpleos"
                    className="btn btn--gradient"
                  >
                    Busqueda Avanzada
                  </Link> */}
                  <Link to="/user/Guardados" className="btn btn--gradient" id="Empleos_Guardados">
                    Empleos Guardados
                  </Link>
                  <Link to="/user/Aplicados" className="btn btn--gradient" id="Empleos_Guardados">
                    Empleos Aplicados
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="busquedad">
          <div className="container">
            <div className="row box">
              <div className="title">Ofertas de Empleo</div>

              <div className="text-center">
                <i className="fas fa-search"></i>
                <input
                  type="text"
                  placeholder="Empresa, Cargo, Tipo empleo, Ubicación, Ciudad"
                  onChange={this.filterRecommends}
                ></input>
              </div>
              {/* <div class="bottom-content">Ver todas las publicaciones</div> */}
              <Link to="/user/BusquedaEmpleos" className="bottom-content">
                Búsqueda Avanzada
              </Link>
            </div>
          </div>
        </section>
        <Recomendaciones
          data={this.state.recomendaciones}
          applicant={this.state.applicant}
          change={this.sortData}
        ></Recomendaciones>
      </div>
    );
  }
}
